import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { TNButtonProps } from './TNButton'
import { calcRem, fonts, metrics } from '../../__styling'

const { uplate, utility, white } = tokens.thenightly.colors.palette
const { sm, sm2l, m2l } = metrics.thenightly.margins

export interface StyledTNButtonProps extends TNButtonProps {}

const colorMap: Record<
    StyledTNButtonProps['btnType'],
    { default: string; disabled: string }
> = {
    primary: { default: uplate.default, disabled: uplate.light },
    danger: { default: utility.error.default, disabled: utility.error.light },
    muted: { default: white, disabled: white },
}

export const StyledTNButton = styled('button')<StyledTNButtonProps>(
    ({ btnType, disabled = false }) => ({
        fontFamily: fonts.thenightly.sansSerif,
        border: 'none',
        background: disabled
            ? colorMap[btnType].disabled
            : colorMap[btnType].default,
        color: btnType === 'muted' ? colorMap.primary.default : white,
        padding: calcRem(sm2l, m2l),
        borderRadius: '8px',
        fontWeight: 600,
        lineHeight: '150%',
        cursor: disabled ? 'no-drop' : 'pointer',
        marginLeft: calcRem(sm),
    }),
)
